import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody, Button } from "reactstrap";

function ErrorFallback({ onRetry }) {
  const { t } = useTranslation();
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
      <Card className="shadow border-0 text-center" style={{ maxWidth: 480 }}>
        <CardBody className="py-5 px-4">
          <div
            className="rounded-circle bg-danger d-inline-flex align-items-center justify-content-center mb-3"
            style={{ width: 64, height: 64 }}>
            
            <i className="ni ni-notification-70 text-white" style={{ fontSize: 28 }} />
          </div>
          <h3 className="mb-2">{t("errorBoundary.title")}</h3>
          <p className="text-muted mb-4">
            {t("errorBoundary.message")}
          </p>
          <Button color="primary" onClick={onRetry}>
            <i className="ni ni-curved-next mr-1" />
            {t("errorBoundary.retry")}
          </Button>
        </CardBody>
      </Card>
    </div>);

}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return <ErrorFallback onRetry={this.handleRetry} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
